import * as types from "./mutation-type";
import { getDepartmentsQuery,getStoreDepartmentsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getDepartments({ commit }, variables = {}) {
    try {
      commit(types.GET_DEPARTMENTS_BEGIN);
   
      const {
        data: {
          data
        }
      } = await gqlClient.query({
        query     : variables.isStore ? getStoreDepartmentsQuery : getDepartmentsQuery,
        variables : variables
      });
      commit(types.GET_DEPARTMENTS_SUCCESS, variables.isStore ? data.store.departments:data.company.departments);
    } catch (e) {
      commit(types.GET_DEPARTMENTS_ERROR, e);
    }
  },
  async deleteDepartment({ commit }, id) {
    commit(types.DELETE_DEPARTMENT_BEGIN);
    try {
      await api.department.deleteDepartment(id);
      commit(types.DELETE_DEPARTMENT_SUCCESS, id);

    } catch (e) {
      commit(types.DELETE_DEPARTMENT_ERROR, e);
    }
  },

  //create new department
  async createDepartment({ commit }, variables ) { 
    try {
      commit(types.CREATE_DEPARTMENT_BEGIN)
      const { data } = await api.department.addDepartment(variables)
      commit(types.CREATE_DEPARTMENT_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_DEPARTMENT_ERROR, e)
    }
  },

  //update department by its id
  async updateDepartment({ commit }, { id, data }){
    commit(types.UPDATE_DEPARTMENT_BEGIN)
    try {
      const { data:updatedData } = await api.department.update(id,data)
      commit(types.UPDATE_DEPARTMENT_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_DEPARTMENT_ERROR, error)
    }
  },

  //create department in user_emp section
  async createUserDepartment({ commit, rootState }, userData) { 
    try {
      commit(types.ADD_USER_DEPARTMENT_BEGIN,userData.userId)
      const { data } = await api.userDepartment.addUserDepartment(userData)
      commit(types.ADD_USER_DEPARTMENT_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_USER_DEPARTMENT_ERROR, { err,userId : userData.userId })
    }
  },

  //delete department in user_emp section
  async deleteUserDepartment({ commit, rootState }, { id, userId }) {
    try {
      commit(types.DELETE_USER_DEPARTMENT_BEGIN, userId);
      await api.userDepartment.deleteUserDept(id);
      
      commit(types.DELETE_USER_DEPARTMENT_SUCCESS, { userId, rootState });
    } catch (err) {
      commit(types.DELETE_USER_DEPARTMENT_ERROR, { err, userId });
    }
  }
};

export default actions;